export default __webpack_public_path__ + "static/media/Icono8.1c853cb5.svg";